<template>
  <div>
    <el-dialog
        :visible.sync="isOpen"
        :show-close="true"
        :before-close="handleClose"
        :top="'15px'"
        class="create_dialog">
      <div class="body_dialog">
        <div class="survey_form">

          <!--    Ảnh mở đầu phiếu    -->
          <section class="wrap_image_form radius border">
            <el-image class="main_image" :src="defaultDataForm.imgWeb"/>
          </section>

          <!--    Phần tiêu đề và mô tả phiếu    -->
          <section class="header_survey_form radius border element_form">
            <div class="header_survey_title">
              <span>{{defaultDataForm.title}}</span>
            </div>

            <div class="header_survey_description">
              {{defaultDataForm.description}}
            </div>
          </section>

          <!--    Phần câu hỏi phiếu    -->
          <section class="wrap_question" ref="wrapQuestion">
            <div
                class="radius border element_form"
                v-for="(question, index) in defaultDataForm.questionResponseList"
                :key="index"
                :ref="`elementForm-${index}`"
                @click="handleElementClick(index)"
            >
              <div class="element_body">
                <el-row type="flex" :gutter="14">
                  <el-col :span="24">
                    <div class="element_question">
                      <div class="question_title">
                        {{question.questionText}}
                        <span v-if="question.obligatory" style="color: red">*</span>
                      </div>

                      <!--   Với câu hỏi văn bản   -->
                      <el-input
                          v-if="question.typeQuestion === 'Text'"
                          type="textarea"
                          placeholder="Văn bản trả lời"
                          :maxlength="500"
                          :show-word-limit="true"
                          :rows="3"
                          :disabled="true"
                          :autosize="{minRows: 3, maxRows: 6}"
                      />

                      <!-- Với câu hỏi hộp kiểm (checkbox) -->
                      <div
                          v-if="question.typeQuestion === 'CheckBox'"
                          class="wrap_checkbox"
                      >
                        <el-checkbox
                            :disabled="true"
                            v-for="(item, indexOption) in question.valueQuestionArray"
                            :label="item.value"
                            :key="indexOption"
                            class="container_checkbox"
                        >
                          <div style="color: #000; ">
                            {{item.value}}
                          </div>
                        </el-checkbox>
                      </div>

                      <!-- Với câu hỏi trắc nghiệm (radio) -->
                      <div
                          v-if="question.typeQuestion === 'Radio'"
                          class="wrap_checkbox"
                      >
                        <el-radio
                            :disabled="true"
                            v-for="(item, index) in question.valueQuestionArray"
                            :label="item.value"
                            :key="index"
                            class="container_checkbox"
                        >
                          <div style="display: inline-block; color: #000;">
                            {{item.value}}
                          </div>
                        </el-radio>
                      </div>

                      <!--   Với câu hỏi chọn điểm   -->
                      <div style="padding-left: 14px" v-if="question.typeQuestion === 'Point'">
                        <div style="display: flex; gap: 0 16px">
                          <div
                              v-for="(item, index) in 10"
                              :key="index"
                          >
                            <div
                                style="
                              display: flex;
                              justify-content: center">
                            <span
                                class="option_point"
                            >
                              {{ item }}
                            </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--   Với câu hỏi đánh giá (Sao)   -->
                      <div style="padding-left: 14px" v-if="question.typeQuestion === 'Star'">
                        <div style="display: flex; gap: 0 16px">
                        <span v-for="item in 5" :key="item" class="icon_star">
                          <i class="el-icon-star-off"/>
                        </span>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div slot="footer">
        <div style="padding: 10px 0">
          <el-button @click="handleClose" type="danger">
            <i class="el-icon-circle-close"/>
            Đóng
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import icon from "@/assets/icons";
import FormSystemService from "@/services/AdminService/FormSystemService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      defaultDataForm: {
        idForm: undefined,
        imgWeb: undefined,
        title: "Tiêu đề phiếu khảo sát",
        description: "Mô tả phiếu khảo sát",
        questionResponseList: [
          {
            idQuestion: null,
            questionText: "",
            valueQuestion: "",
            typeQuestion: "Text",
            obligatory: false,
            valueQuestionArray: [
              {
                value: "",
              }
            ],
          }
        ]
      },
      typeQuestionOptions: [
        {
          icon: icon.text,
          label: "Văn bản",
          value: "Text"
        },
        {
          icon: icon.checkbox,
          label: "Hộp kiểm",
          value: "CheckBox"
        },
        {
          icon: icon.radio,
          label: "Trắc nghiệm",
          value: "Radio"
        },
        {
          icon: icon.point,
          label: "Điểm",
          value: "Point"
        },
        {
          icon: icon.rating,
          label: "Đánh giá",
          value: "Star"
        }
      ],
      currentQuestionIndex: 0,
    }
  },

  methods: {
    setCurrentQuestionIndex(index) {
      this.currentQuestionIndex = index;
    },

    handleClose() {
      this.$emit("closeDialog");
    },

    resetData() {
      this.defaultDataForm = {
        idForm: undefined,
        imgWeb: undefined,
        title: "Tiêu đề phiếu khảo sát",
        description: "Mô tả phiếu khảo sát",
        questionResponseList: [
          {
            idQuestion: null,
            questionText: "",
            valueQuestion: "",
            typeQuestion: "Text",
            obligatory: false,
            valueQuestionArray: [
              {
                value: "",
              }
            ],
          }
        ]
      }
      this.currentQuestionIndex = 0;
    },

    handleElementClick(index) {
      this.setCurrentQuestionIndex(index);
    },

    handleInitialData(id) {
      FormSystemService.getDataById(id)
          .then((res) => {
            const data = res.data.data;

            data.questionResponseList.map((item) => {
              item["valueQuestionArray"] = [];
              if (item.typeQuestion === "CheckBox" || item.typeQuestion === "Radio") {
                item["valueQuestionArray"] = item.valueQuestion.split(";").map(item => ({value: item}));
              }
            });

            this.defaultDataForm = data;
          })
          .catch((err) => {
            console.log(err);
          })
    },
  }
}
</script>

<style lang="scss" scoped>
.title_dialog {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
}

.dialog_image {
  /deep/ .el-dialog__header {
    background-color: transparent;
  }
}

.body_dialog {
  display: flex;
  justify-content: center;

  .survey_form {
    width: 80%;
  }
}

.wrap_image_form {
  height: 192px;
  position: relative;

  .image_form {
    width: 100%;
    height: 100%;

    /deep/ .el-image__inner {
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}

.radius {
  border-radius: 10px;
  overflow: hidden;
}

.border {
  border: 1px solid #dadce0;
}

.element_form {
  margin-top: 10px;
  padding: 30px 34px 30px 34px;
  box-shadow: 0 0 8px 0 #DCDFE6;

  /deep/ input,
  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: initial;
    color: #000;

    &:focus {
      border-bottom: 3px solid #78a5e7;
    }
  }

  /deep/ textarea::placeholder,
  /deep/ input::placeholder {
    color: #7b7b7b;
  }
}

.element_question {
  display: flex;
  flex-direction: column;

  .question_title {
    font-size: 14px;
    font-family: system-ui;
    color: #000;
    font-weight: 500;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #78a5e7;
  }

  /deep/ textarea {
    border-radius: initial;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: 0 56px 0 14px;
  }
}

.header_survey_form {
  .header_survey_title {
    font-size: 24px;
    font-weight: 900;
    color: #000;
    font-family: system-ui;
    padding-bottom: 16px;
    border-bottom: 2px solid #78a5e7;

    /deep/ input::placeholder {
      font-size: 22px;
      font-weight: 500;
    }
  }

  .header_survey_description {
    font-family: system-ui;
    font-size: 14px;
    white-space: pre-line;
  }
}

.element_footer {
  padding: 30px 0 0 0;
  border-top: 1px solid #dadce0;
  display: flex;
  justify-content: end;
  gap: 0 34px;
  align-items: center;
  font-size: 18px;
}

.wrap_require {
  display: flex;
  align-items: center;
  gap: 0 18px;
  padding-left: 32px;
  border-left: 1px solid #dadce0;

  .label_require {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
}

.wrap_checkbox {

}

.checkbox_options {
  /deep/ input {
    width: 350px;
  }
}

.option_point {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  border: 2px solid #b4b4b4;
  border-radius: 6px;
  color: #4e4e4e;
  font-weight: 600;
  background-color: #d6d6d6;
  cursor: not-allowed;
}

.icon_star {
  font-size: 34px;
  cursor: not-allowed;
}

.wrap_button_tasks {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 14px;
}

.wrap_question {
  position: relative;

  .scroll_tasks {
    position: absolute;
    right: -61px;
    top: 0;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    width: 50px;
    min-height: 28px;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
    gap: 10px 0;
    box-shadow: 0 0 8px 0 #DCDFE6;
    border: 1px solid #dadce0;
    transition: top 0.3s ease-in;

    .btn_scroll_tasks {
      font-size: 24px;
      cursor: pointer;
    }
  }
}

.upload_image_form {
  position: absolute;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /deep/ .el-upload {
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px dashed #6f6f6f;
    z-index: 1;
    background-color: transparent;

    i {
      font-size: 20px;
    }
  }

  /deep/ .el-upload-list__item {
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: none;
  }

  .container_image {
    height: 100%;
    width: 100%;

    img {
      object-fit: cover;
      object-position: center;
    }
  }
}

.dialog-footer {
  width: 50%;
}

.main_image {
  width: 100%;
  height: 100%;

  /deep/ .el-image__inner {
    object-fit: cover;
    object-position: center;
  }
}

.container_checkbox {
  display: block;
  margin-bottom: 12px;
}

.wrap_checkbox {
  padding-left: 14px;
}
</style>